<template>
    <div :class="mainClass">
        <page-header
            v-if="includeHeader"
            :title="title"
            :breadcrumbs="breadcrumbs"
            :back-route="backRoute"
        />

        <tabs
            v-if="tabsElements.length"
            :items="tabsElements"
            :active-item="activeTab"
            :actions="tabActions"
            is-card
            class="mb-3"
            @action="onTabAction"
            @item-change="activeTab = $event"
        />

        <awesome-table
            :key="tableKey"
            :labels="tableLabels"
            :items="items"
            :pagination="pagination"
            :filters="filters"
            :options="options"
            :is-loading="isLoading"
            :get-row-class="getRowClass"
            @row-click="onRowClick"
            @pagination-change="onPaginationChange"
            @add-button-click="onAddButtonClick"
            @filter-change="onFilterChange"
            @refresh="onRefresh"
            @selected-items="onSelectedItems"
        >
            <template #selectButtons="{ clearSelected }">
                <button
                    class="btn btn-danger waves-effect waves-light mr-1"
                    type="button"
                    @click="doBatchDestroy(selected, clearSelected)"
                >
                    <i class="fas fa-minus-circle" /> Delete selected
                </button>
            </template>

            <template #[`labels.actions`]="{ label }">
                <span style="color: gray">
                    {{ label }}
                </span>
            </template>
            <template #[`items.actions`]="{ item, index }">
                <button
                    v-for="(action, actionIndex) in tableActions"
                    v-show="isActionVisible(action, item)"
                    :key="`action_${actionIndex}`"
                    class="action-button"
                    @click.stop="callAction(action, item.id, index)"
                >
                    <i :class="action.icon" />
                </button>
            </template>

            <template #globalActionButtons>
                <button
                    class="btn btn-success waves-effect waves-light mr-1 mb-1"
                    @click="chooseFileToImport"
                >
                    <i class="fas fa-file" />

                    Import
                </button>
            </template>
        </awesome-table>

        <confirmation-modal
            :content="confirmationModalContent"
            @agree="removeItem"
            @disagree="idToDelete = null"
        />

        <component
            :is="item.name"
            v-for="item of additionalComponents"
            :key="item.name"
            v-bind="item.props || {}"
            v-on="item.events || {}"
        />

        <input v-show="false" ref="upload" type="file" @change="doImportFile" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import { StatusCodes } from '@/enums/redirects';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Redirects'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Redirects'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'title', width: '150px' },
                { value: 'from', width: '150px' },
                { value: 'to', width: '150px' },
                {
                    value: 'statusCode',
                    type: 'enum',
                    enumOptions: Object.values(StatusCodes),
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'redirects/index',
            deleteItem: 'redirects/destroy',
            importFile: 'redirects/import',
            batchDestroy: 'redirects/batchDestroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/redirects/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/redirects/add');
        },

        chooseFileToImport() {
            this.$refs?.upload?.click();
        },

        async doImportFile(event) {
            const [file] = event.target.files;

            if (!file) {
                return;
            }

            const formData = new FormData();

            formData.append('file', file);

            await this.importFile(formData);

            this.$refs.upload.value = null;

            this.fetchItems();
        },

        async doBatchDestroy(selected, clearSelected) {
            await this.batchDestroy(selected);

            clearSelected();

            await this.fetchItems();
        }
    }
};
</script>
